import { render, staticRenderFns } from "./GeneralConfig.vue?vue&type=template&id=2479be43"
import script from "./GeneralConfig.vue?vue&type=script&lang=js"
export * from "./GeneralConfig.vue?vue&type=script&lang=js"
import style0 from "./GeneralConfig.vue?vue&type=style&index=0&id=2479be43&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports